import { SolanaContractAddresses } from '@repo/types-client';

const _registry: Record<string, SolanaContractAddresses> = {
  mainnet: {
    doopies: '7ifrcfFwVLBUKCo8smEK44npokR1xK8KHopRV98Moj8f',
  },
  devnet: {
    doopies: '7ifrcfFwVLBUKCo8smEK44npokR1xK8KHopRV98Moj8f',
  },
};

let _selectedNetwork: SolanaContractAddresses;

switch (process.env.NEXT_PUBLIC_APP_ENV) {
  case 'production':
    _selectedNetwork = _registry.mainnet ?? ({} as SolanaContractAddresses);
    break;
  default:
    _selectedNetwork = _registry.devnet ?? ({} as SolanaContractAddresses);
    break;
}

export const solanaContractAddresses =
  _selectedNetwork as Readonly<SolanaContractAddresses>;
